import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin(() => {
  let loaded = false;

  function loadScript() {
    if (!loaded) {
      loaded = true;

      const script = document.createElement('script');
      script.src =
        'https://consent.cookiefirst.com/sites/g-portal.com-36457fbc-dedb-4ca8-83be-e6b461e12c80/consent.js';
      document.head.appendChild(script);
    }
  }

  // We need to wait for the Nuxt app to be ready, then we wait for the user to
  // interact with the page before loading the CookieFirst script. This is
  // because we don't want to show the banner to bots or crawlers (e.g. Google)
  onNuxtReady(() => {
    if (navigator.userAgent.indexOf('CookieCheck') !== -1) {
      loadScript();
    } else {
      document.addEventListener('mousemove', loadScript, { once: true });
      document.addEventListener('click', loadScript, { once: true });
      document.addEventListener('scroll', loadScript, {
        once: true,
        passive: true,
      });
    }
  });
});
